import React from 'react';
import PropTypes from 'prop-types';
import InfoBox from 'components/widget/InfoBox';
import moment from 'moment';

const Component = ({ newProduct, currentProduct, deliveryDate }) => {
  if (newProduct.packSize.usage !== currentProduct.packSize.usage) {
    return (
      <InfoBox>
        Will switch to &apos;
        {newProduct.packSize.usage}
        &apos; package after your&nbsp;
        {moment(deliveryDate).format('MMMM Do')}
        &nbsp;delivery.
      </InfoBox>
    );
  }

  if (!!newProduct.hasSolution !== !!currentProduct.hasSolution) {
    return (
      <InfoBox>
        Your package will&nbsp;
        {!newProduct.hasSolution && 'not '}
        include solution after your&nbsp;
        {moment(deliveryDate).format('MMMM Do')}
        &nbsp;delivery.
      </InfoBox>
    );
  }

  return null;
};

Component.propTypes = {
  newProduct: PropTypes.shape({
    hasSolution: PropTypes.bool,
    packSize: PropTypes.shape({
      usage: PropTypes.string,
    }),
  }).isRequired,
  currentProduct: PropTypes.shape({
    hasSolution: PropTypes.bool,
    packSize: PropTypes.shape({
      usage: PropTypes.string,
    }),
  }).isRequired,
  deliveryDate: PropTypes.string.isRequired,
};
export default Component;
